import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { T2TemplateBasicComponent } from 'app/trip2-theme/components/t2-template-basic/t2-template-basic.component';
import { ManagerReportsComponent } from './manager-reports.component';

const routes: Routes = [{
  path: 'pages',
  component: T2TemplateBasicComponent,
  children: [{
    path: 'manager-reports',
    component: ManagerReportsComponent,
    data: {
      title: 'Reports'
    }
  }]
}];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: []
})
export class ManagerReportsRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/pages/manager-reports/manager-reports-routing.module.ts